import React from "react";

import { MobileDeviceStatusCard } from "./MobileDeviceStatusCard";
import { ConnectedMobileDeviceStatusCardProps } from "./MobileDeviceStatusCard.types";

export const ConnectedMobileDeviceStatusCard: React.FC<ConnectedMobileDeviceStatusCardProps> =
  ({ testResult, deviceName }) => {
    return (
      <MobileDeviceStatusCard testResult={testResult} deviceName={deviceName} />
    );
  };
